import { t } from 'i18next';
import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { iconPlus } from '@/components/icons';
import { baseStyles, buttonStyles } from '@/styles';

import '@/components/accordion/fg-accordion-divider';

@customElement('fg-accordion-footer')
export class FgAccordionFooter extends LitElement {
  @property({ type: String })
  queryString: string | null | undefined;

  @property({ type: String })
  buttonText = 'actions.addExtraPrintPosition';

  updateComponent(queryString: string | null | undefined) {
    if (queryString === null || queryString === undefined) {
      console.error('Missing query string');
      return;
    }
    this.dispatchEvent(
      new CustomEvent('option-selected', {
        composed: true,
        detail: { option: { queryString } },
      }),
    );
  }

  render() {
    if (!this.queryString) {
      return nothing;
    }

    return html`
      <fg-accordion-divider></fg-accordion-divider>
      <button
        type="button"
        class="button-as-link button-icon add-extra-option"
        @click=${() => this.updateComponent(this.queryString)}
      >
        <span aria-hidden="true">${iconPlus}</span>
        ${t(this.buttonText)}
      </button>
    `;
  }

  static styles = [
    baseStyles,
    buttonStyles,
    css`
      .add-extra-option span {
        background-color: var(
          --fg-primary--light,
          var(--fg-fallback-primary--light)
        );
        border-radius: 50%;
        color: var(--fg-primary, var(--fg-fallback-primary));
        display: inline-grid;
        flex-shrink: 0;
        height: 24px;
        padding: 4px;
        place-content: center;
        width: 24px;
      }
    `,
  ];
}
